import AImage from './AImage.js';

export default class Abutton extends AImage
{
    constructor(scene, x, y, texture, upFrame, config, onClick)
    {
        super(scene, x, y, texture, upFrame);

        this.setInteractive();
        this.upFrame = upFrame;
        this.onClick = onClick;
        this.btnTexture = texture;
        this.isDown = false;
        this.config = config;
        this.downTime = 0;
        this.originalTint = 0xffffff;

        this.on('pointerdown', (pointer) => { this.eh_PointerDown(pointer); });
        this.on('pointerup', () => { this.eh_PointerUp(); });
        this.on('pointerout', () => { this.eh_PointerUp(); });
        // this.scene.input.on('pointerup', ()=>{this.eh_PointerUp();});
    }

    set tint(value)
    {
        this.originalTint = value;
        super.tint = value;
    }

    destroy()
    {
        this.scene.removeButton(this);
        super.destroy();
    }

    eh_PointerDown(pointer)
    {
        if(!this.input.enabled) return;

        if(this.upFrame === "dodgeBtn") this.scene.dodgeDown();
        
        this.isDown = true;
        this.downTime = this.scene.time.now;

        this.depressButton();
        this.onPointerDown();
    }

    eh_PointerOut()
    {
        if(!this.input.enabled) return;

        this.unpressButton();
        this.isDown = false;
        this.onPointerOut();
    }

    eh_PointerUp()
    {
        if(!this.input.enabled) return;

        this.unpressButton();

        if(this.isDown)
        {
            this.isDown = false;
            if(this.onClick!= null) // && (this.scene.time.now - this.downTime) < 550
            {
                this.onClick();
            }
        }
        this.onPointerUp();
    }

    setEnabled(enabled)
    {
        this.input.enabled = enabled;
        if(!enabled)
        {   
            this.disableInteractive();
            this.depressButton();
        }
        else
        {
            this.setInteractive();
            this.unpressButton();
        }
    }

    onPointerDown(){} //OVERRIDE THESE GUYS
    onPointerUp(){}
    onPointerOut(){}

    depressButton()
    {
        if(this.config.frameOnDown != null) this.setFrame(this.config.frameOnDown, false, false);
        if(this.config.scaleOnDown != null) this.setScale(this.config.scaleOnDown);
        if(this.config.tintOnDown != null) super.tint = this.config.tintOnDown;
    }
    
    unpressButton()
    {
        if(this.config.frameOnDown != null) this.setFrame(this.upFrame, false, false);
        if(this.config.scaleOnDown != null) this.setScale(1);
        if(this.config.tintOnDown != null) this.tint = this.originalTint;
    }


    update()
    {
        let temp = this.scene.input.activePointer;
        // console.log(temp.isDown);
    
        if(!temp.isDown && this.isDown)
        {
            this.eh_PointerOut();
        }
    }
}